import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { PictureAsPdf } from '@mui/icons-material';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import isEmpty from 'helpers/isEmpty';
import { useNavigate } from 'react-router-dom';
import { buildRoute } from 'routes';

const getFileType = (url) => (/\.pdf(\?.*)?$/i.test(url) ? 'pdf' : 'image');

export default function ViewTransactionDocument({ transactionDocument, isLoading }) {
  const navigate = useNavigate();

  const transactionDocumentUrl = transactionDocument?.url || '';

  if (isLoading) {
    return <Box>Loading...</Box>;
  }

if (
  !transactionDocument ||
  !transactionDocument.documentsList ||
  transactionDocument.documentsList.length === 0
) {
  if (!isEmpty(transactionDocumentUrl)) {
    return (
      <PhotoProvider>
        <PhotoView src={transactionDocumentUrl}>
          <Box
            component="img"
            src={transactionDocumentUrl}
            alt="transaction-document"
            sx={{
              width: 250,
              height: 'auto',
              borderRadius: 2,
              cursor: 'pointer',
              boxShadow: 2,
            }}
          />
        </PhotoView>
      </PhotoProvider>
    );
  }

  return <Typography>No Document Available</Typography>;
}



  const transactionId = transactionDocument?.transactionId;

  const receiptDoc = transactionDocument.documentsList.find(
    (doc) => doc.documentName?.toLowerCase() === 'receipt',
  );
  const receiptUrl = receiptDoc?.url;
  const fileType = getFileType(receiptUrl);

  return (
    <Box>
      <Typography fontWeight={600} fontSize={18} marginBottom={2}>
        Receipt
      </Typography>

      {!isEmpty(receiptUrl) && (
        <>
          {fileType === 'pdf' ? (
            <Button
              href={receiptUrl}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: 220,
                height: 150,
                borderRadius: 2,
                textTransform: 'none',
                color: 'text.secondary',
                '&:hover': { bgcolor: 'grey.100' },
                mb: 2,
              }}
            >
              <PictureAsPdf sx={{ fontSize: 40, mb: 1, color: 'error.main' }} />
              <Typography variant="caption" noWrap>
                View PDF
              </Typography>
            </Button>
          ) : (
            <PhotoProvider>
              <PhotoView src={receiptUrl}>
                <Box
                  component="img"
                  src={receiptUrl}
                  alt="transaction-receipt"
                  sx={{
                    width: 220,
                    height: 'auto',
                    borderRadius: 2,
                    cursor: 'pointer',
                    boxShadow: 2,
                    mb: 2,
                  }}
                />
              </PhotoView>
            </PhotoProvider>
          )}
        </>
      )}

      <Button
        fullWidth
        variant="contained"
        onClick={() => navigate(buildRoute('transaction.docs', transactionId))}
        sx={{ mt: '10px' }}
      >
        View Document
      </Button>
    </Box>
  );
}
